import { ICoupon, IGiftCard } from '../../interfaces/coupon';

const REFILLS_ID = 'SWB_REFILLS';
const GIFTCARD_MESSAGE =
  'Your gift card has been applied! Any remaining credit will be added to your account.';
const NINETY_REFILLS_ID = '_90DAY_REFILLS';

const generateCouponText = (couponData: ICoupon | IGiftCard) => {
  if (!('couponType' in couponData)) return GIFTCARD_MESSAGE;
  const couponName = couponData.code.toUpperCase();
  if (couponData.couponType === REFILLS_ID || NINETY_REFILLS_ID === couponData.couponType) {
    return `${couponName} has been applied for 1 Free Refill: ${couponData.gwpRefillProductName} Subscription`;
  }

  return `${couponName} has been applied`;
};

export { generateCouponText };
